import { Modal } from 'antd';

import { Schemas } from '@api-client/generated/types';
import { FilePreview } from '@entities';

type TaxFilePreviewModalProps = {
  file: Schemas.AdminObligationFileResponseDto | null;
  open: boolean;
  onClose: () => void;
};

const TaxFilePreviewModal = ({
  file,
  open,
  onClose,
}: TaxFilePreviewModalProps) => (
  <Modal
    width={620}
    open={open}
    title={file?.name || file?.fileName || 'File'}
    footer={null}
    onCancel={onClose}
    destroyOnClose
    centered
  >
    <FilePreview file={file} width="100%" />
  </Modal>
);

export default TaxFilePreviewModal;
